import React from 'react'
import PropTypes from 'prop-types'

// Components
import { ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles'

// Styles
import { createTheme } from 'theme'

const ThemeProvider = ({ children }) => {
  // Will integrate dark mode as part of user settings in future updates.
  const darkMode = false

  const themeWithUserSettings = React.useMemo(() => {
    return createTheme({ darkMode })
  }, [darkMode])

  return <MuiThemeProvider theme={themeWithUserSettings}>{children}</MuiThemeProvider>
}

ThemeProvider.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
}

export default ThemeProvider
